// extracted by mini-css-extract-plugin
module.exports =  {"loader":"DependenciesChain__loader--yJ","unit":"var(--ring-unit)","container":"BuildTypeChainContent__container--HP","innerContainer":"BuildTypeChainContent__innerContainer--nT"};